import React, { useContext } from 'react';
import { ItemContext } from 'modules/react-accordion/components/accordionItem';

export interface ITeaser {
    teaserLength?: number;
}

export function hasTeaserGuard<T>(props: T | ITeaser): props is ITeaser {
    return (props as ITeaser).teaserLength !== undefined;
}

const withTeaser = <T,>(WrappedComponent: React.FC<React.PropsWithChildren<T>>): React.FC<React.PropsWithChildren<T & ITeaser>> => (props) => {
    const { children, teaserLength } = props;
    const { isExpanded } = useContext(ItemContext);
    const teaserText = teaserLength && (children as string).substring(0, teaserLength);

        return (
            <WrappedComponent {...props}>
                {teaserText && !isExpanded && <div>{teaserText}...</div>}
                <div hidden={!isExpanded}>{children}</div>
            </WrappedComponent>
        );
    };

export default withTeaser;
